import React from 'react';
import PrintTools from '@/components/admin/PrintTools';
import { SPAThemeScope } from '@/components/admin/SysadminSPA/shared/SPAThemeScope';
import cn from '@/utils/cn';

interface PrintToolsPageProps {
  analyzePath: string;
}

// The standalone /admin/print_tools page. The tool is on the SPA tokens, which default dark on
// :root, so the legacy (light) page pins the light set the way admin/ProgramsPage does. No ground
// colour of its own: the tool sits on the legacy page's white, so its surfaces read as they do on
// the SPA's light surface.
export const LEGACY_THEME_CLASS = 'spa-theme-light';

export const legacyGroundClass = cn(LEGACY_THEME_CLASS, 'tw-text-spa-on-bg');

const PrintToolsPage = ({ analyzePath }: PrintToolsPageProps) => (
  <SPAThemeScope className={LEGACY_THEME_CLASS}>
    <div className={legacyGroundClass}>
      <PrintTools analyzePath={analyzePath} />
    </div>
  </SPAThemeScope>
);

export default PrintToolsPage;
